<div class="container">
    <b-overlay :show="isLoading" rounded="sm">
        <div class="col-md-3 mb-4">
            <img v-if='(product.img)' class="img-fluid img-thumbnail" :src="product.img" :alt="product.text" />
        </div>
        <!--product details-->
        <b-row>
            <b-col>
                <h2>{{product.text}}</h2>
            </b-col>
            <b-col>
                <b-button @click="showNotification = true" variant="outline-primary"><i class="ni ni-cart"></i> Cart
                    <b-badge variant="success">{{qtyCheckTotal()}}</b-badge>
                </b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <div class="alert alert-primary"> Collection is Wednesday and Saturday 9am - 3pm.
                    Shop no.6, Cnr H Chitepo/L. takawira, Bulawayo
                </div>
            </b-col>
        </b-row>
        <div class="p-1">

            <!--price selector-->
            <div class="col-lg-12">
                <div class="row row-grid">
                    <div v-for="(value, name, index) in priceList.productList" :value="value" :key="name"
                        class="col-lg-4 col-mb-4 my-2">
                        <b-card>
                            <b-card-text class="text-center"><img :src='value.extra2' class=""></b-card-text>
                            <b-card-text>
                                <h4>{{qtyCheckPerItemAndTitle(value)}}</h4>
                            </b-card-text>
                            <b-card-text>{{product.isoCurrency}}{{ value.totalAmount }}
                            </b-card-text>
                            <div class="row">
                                <div class="col-sm-8">
                                    <b-form-group>
                                        <b-form-input :id="value.extra1" type="number" step="1" min="0" max="100"
                                            :value='qtyCheck(value)' placeholder=""></b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col-sm-4">
                                    <b-button @click='addToCart(value)' variant="default" size="sm">
                                        <icon name="ni ni-basket" size="sm"> </icon>Add
                                    </b-button>
                                </div>
                            </div>
                        </b-card>
                    </div>
                </div>
            </div>
            <!--price selector-->
            <div>
                <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>

            </div>
            <br />

        </div>
        <!--product details-->
    </b-overlay>
    <!--Model-->
    <b-modal v-model="showNotification" hide-footer title="Cart">
        <div v-for="(value, name, index) in itemsInCart" :value="value" :key="name">
            <div class="row">
                <div class="col-sm-8">
                    {{value.count}} x {{value.row.description}}
                </div>
                <div class="col-sm-4">
                    R{{value.lineTotalAmount.toFixed(2)}}
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-8">
                <strong>Total</strong>
            </div>
            <div class="col-sm-4">
                <strong>R{{basketTotalCost.toFixed(2)}}</strong>
            </div>
        </div>
        <div class="row">
            <base-button class="btn-3" @click="proceed()" type="primary" icon="ni ni-credit-card">
                Proceed
            </base-button>
            <base-button type="white" @click="showNotification = false">
                Close
            </base-button>
        </div>
    </b-modal>
    <!--model-->
</div>